import { Grid, styled } from "@mui/material";

export const ItemBox = styled(Grid)({
  position: "relative",
  background: "white",
  minHeight: "70px",
  padding: "2px 10px",
  marginTop: "5px",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "16px",
  "&:hover": {
    borderRight: "solid 1px",
    borderLeft: "solid 1px",
  },
});
